export default class AllReviews {
  constructor() {
    this.$header = $('.jdgm-all-reviews__header');

    this._displayReviewScore();
    $(window).on('load', this._activateShopTab.bind(this));
  }

  _displayReviewScore() {
    const reviewsScore = new Number(this.$header.attr('data-average-rating'));
    this.$header.prepend(`<div class="reviews-average-rating">${reviewsScore.toString()}/5</div>`)
  }

  _activateShopTab() {
    $('[data-tabname="shop-reviews"]').trigger('click');
  }
}